// extracted by mini-css-extract-plugin
module.exports = {"btn-color":"_3ku35S065dbdMapoVWkdAE","text-left":"_aMb34dk2dZ4dX_B2tOFc"};